import React, { useState } from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Empty, Button, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import Page from 'components/Page';
import Loading from 'components/Loading';
import DateRangePicker from 'components/DateRangePicker';
import { getDefaultDateRange } from 'shared/constants/date';
import globalMessages from 'translations/messages';
import ResultsPage from 'containers/Results/ResultsPage';
import { useLocalStorageState } from 'ahooks';
import EditFunnelDrawer from './EditFunnelDrawer';

const QUERY = gql`
  query($id: ID!) {
    funnel(id: $id) {
      id
      title
      customer { id }
      website { id title }
      steps {
        id
        title
        sortIndex
        filter {
          id
          surveyGroupId
          displayedSurveyId
          filterSegments {
            id
            filterOptions { id relationId options type }
          }
        }
      }
    }
  }
`;

const Funnel = () => {
  const { params } = useRouteMatch('/tools/funnels/:id');
  const { id } = params;
  const history = useHistory();
  const [dateRange, setDateRange] = useLocalStorageState(`funnel-daterange-${id}`, { defaultValue: getDefaultDateRange() });
  const { data, loading } = useQuery(QUERY, { variables: { id } });
  const [editFunnel, setEditFunnel] = useState(false);

  if (loading) {
    return <Loading />;
  }

  const funnel = data?.funnel;

  if (!funnel) {
    return <Empty />;
  }

  const content = [{
    title: funnel.title,
    contentSettings: {
      funnel,
    },
  }];

  return (
    <>
      <Page>
        <Page.Header
          title="Funnel"
          extra={(
            <Space>
              <DateRangePicker
                onChange={setDateRange}
                value={dateRange}
              />
              <Button type="primary" onClick={() => setEditFunnel(true)}>
                <EditOutlined />
                <FormattedMessage {...globalMessages.edit} />
              </Button>
            </Space>
          )}
        />
        <ResultsPage
          dateRange={dateRange}
          content={content}
          customerId={funnel.customer.id}
        />
      </Page>
      <EditFunnelDrawer funnel={funnel} open={editFunnel} onClose={() => setEditFunnel(false)} onDone={() => setEditFunnel(false)} onRemoved={() => history.push('/tools/funnels')} />
    </>
  );
};

export default Funnel;
